import { useRef } from 'react';
import { noop } from './components/utils';
import { TRIGGER_CLICK_KEY_CODES } from './constants';
export function useCardInteractions(_ref) {
  var href = _ref.href,
    disabled = _ref.disabled,
    onClick = _ref.onClick;
  var anchorRef = useRef(null);
  var handleLinkClick = function handleLinkClick(e) {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  var handleCardClick = disabled || !href ? undefined : noop;
  var handleCardKeyDown = function handleCardKeyDown(e) {
    if (disabled) return;
    if (TRIGGER_CLICK_KEY_CODES.includes(e.key)) {
      var _anchorRef$current;
      anchorRef === null || anchorRef === void 0 ? void 0 : (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.click();
    }
  };
  return {
    anchorRef: anchorRef,
    handleLinkClick: handleLinkClick,
    handleCardClick: handleCardClick,
    handleCardKeyDown: handleCardKeyDown
  };
}